import { formatMoney } from '../../lib/formatters.ts'
import type { ForecastLine } from '../../api/cashReport'

export function sourceChipLabel(line: ForecastLine): string | null {
  const rawId = String(line.source_id ?? '')
  if (!rawId || rawId.startsWith('missing:')) return null
  const project = String(line.project_name || line.label || '').trim()
  const amount = formatMoney((Number(line.amount_cents) || 0) / 100)
  const pa = line.pay_app_number || (line.source_type === 'pay_app' || line.source_type === 'expected_in'
    ? rawId
    : null)
  if (pa) {
    const name = project || 'Pay app'
    return `${name} · Pay app ${pa} · ${amount}`
  }
  if (line.source_type && line.source_type !== 'pay_app') {
    const typed = humanType(line.source_type)
    const name = String(line.label || '').trim()
    return name ? `${typed} · ${name}` : `${typed} · ${amount}`
  }
  if (project) return `${project} · ${amount}`
  return `${humanType(line.source_type)} · ${amount}`
}

function humanType(type: string | undefined): string {
  const t = String(type || 'source').replace(/_/g, ' ')
  return t.charAt(0).toUpperCase() + t.slice(1)
}
